import PageLayout from '@upheal/shared/components/shared/LayoutContainers/PageLayout';
import { centerAbsolute } from '@upheal/design-system/legacy-styles/centerAbsolute';
import { Stack } from '@mui/material';
import { swalWarningIcon } from '@upheal/design-system/vendor/swal-upheal';
import SuiTypography from '@upheal/design-system/components/legacy/Sui/SuiTypography';
import SuiButton from '@upheal/design-system/components/legacy/Sui/SuiButton';
import secureBrowsers from '../../utils/secureBrowsers.generated';
import { DateTime } from 'luxon';
import { useCallback, useState } from 'react';
import {
    trackUiEvent,
    uiEventDataAttrs,
} from '@upheal/shared/utils/analytics/ui-tracking';
import { useMount } from 'react-use';
import { SupportArticleLink } from '@upheal/shared/components/shared/SupportArticleLink';

const LOCAL_STORAGE_KEY = 'unsupportedBrowserLastDismiss';

const UnsupportedBrowserDetection = () => {
    const browserSupported = secureBrowsers.test(navigator.userAgent);
    const lastDismissTimestamp = localStorage.getItem(LOCAL_STORAGE_KEY);

    // If the user dismissed the warning today, don't show it again
    const warningDismissedRecently =
        lastDismissTimestamp &&
        DateTime.fromMillis(parseInt(lastDismissTimestamp)) >
            DateTime.now().startOf('day');

    const [showWarning, setShowWarning] = useState(
        !browserSupported && !warningDismissedRecently,
    );

    const dismissWarning = useCallback(() => {
        localStorage.setItem(
            LOCAL_STORAGE_KEY,
            DateTime.now().toMillis().toString(),
        );
        setShowWarning(false);
    }, []);

    useMount(() => {
        if (showWarning) {
            trackUiEvent('View', 'Unsupported Browser');
        }
    });

    if (!showWarning) {
        return null;
    }

    return (
        <PageLayout
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 9999999,
                background: (theme) => theme.palette.offWhite.main,
            }}
        >
            <Stack spacing={2} width={480} sx={centerAbsolute}>
                {swalWarningIcon}
                <Stack>
                    <SuiTypography variant="h3" color="body" textAlign="center">
                        Unsupported browser
                    </SuiTypography>
                    <SuiTypography
                        variant="body1"
                        color="dark"
                        textAlign="center"
                    >
                        Your browser is outdated and might cause the Upheal app
                        to misbehave. Please{' '}
                        <SupportArticleLink href="https://www.wikihow.com/Update-Your-Browser">
                            update it now
                        </SupportArticleLink>{' '}
                        for a smooth experience.
                    </SuiTypography>
                </Stack>
                <SuiButton
                    variant="text"
                    color="action"
                    onClick={dismissWarning}
                    {...uiEventDataAttrs(
                        'Continue Anyway',
                        'Unsupported Browser Warning',
                    )}
                >
                    Continue anyway
                </SuiButton>
            </Stack>
        </PageLayout>
    );
};

export default UnsupportedBrowserDetection;
